import { render, staticRenderFns } from "./SetupTestType.vue?vue&type=template&id=48e5037e&scoped=true&"
import script from "./SetupTestType.vue?vue&type=script&lang=js&"
export * from "./SetupTestType.vue?vue&type=script&lang=js&"
import style0 from "./SetupTestType.vue?vue&type=style&index=0&id=48e5037e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e5037e",
  null
  
)

export default component.exports